import * as React from 'react';
import { useSwiper } from 'swiper/react';

interface ISwiperButtonNextProps {
  children: React.ReactNode;
  className?: string;
}

const SwiperButtonNext: React.FunctionComponent<ISwiperButtonNextProps> = ({
  className,
  children,
}) => {
  const swiper = useSwiper();
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    swiper.slideNext();
  };
  return (
    <button className={`${className} flex items-center`} onClick={handleClick}>
      {children}
    </button>
  );
};

export default SwiperButtonNext;
